export const UNIT_GLOBAL_NAMESPACE = 'app.units';
export const UNIT_LOCAL_NAMESPACE = 'local.units';
export const LAYER_LOCAL_NAMESPACE = 'local.layers';
export const LAYER_GLOBAL_NAMESPACE = 'app.layers';
export const GROUP_GLOBAL_NAMESPACE = 'app.group';
export const GROUP_LOCAL_NAMESPACE = 'local.group';
export const CANVAS_LOCAL_NAMESPACE = 'local.canvas';
export const CANVAS_GLOBAL_NAMESPACE = 'app.canvas';

